import { render, staticRenderFns } from "./PolicyClaims.vue?vue&type=template&id=52d4387d"
import script from "./PolicyClaims.vue?vue&type=script&lang=js"
export * from "./PolicyClaims.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports